export const timelineViewInitialState = {
  engagements: [],
  timeline: [],
  metrics: [],
};
